import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CountdownSection from './components/CountdownSection';
import CoupleSection from './components/CoupleSection';
import StorySection from './components/StorySection';
import CtaSection from './components/CtaSection';
import EventsSection from './components/EventsSection';
import GallerySection from './components/GallerySection';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackgroundMusic from './components/BackgroundMusic';

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <CountdownSection />
      <CoupleSection />
      <StorySection />
      <CtaSection />
      <EventsSection />
      <GallerySection />
      <Footer />
      <ScrollToTop />
      <BackgroundMusic />
    </div>
  );
}

export default App;
